module.exports = __webpack_public_path__ + "static/img/克旗首页-2_04.8cf9c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keqi/克旗首页-2_04.png
// module id = EQq3
// module chunks = 71